import type {
  ApiResponse,
  InventoryHire,
  InventoryHireListRow,
  InventoryItem,
  InventoryStockAdjustReason,
} from '@court-sync/shared';
import { apiDelete, apiGet, apiPatch, apiPost } from './apiClient';

export const clubInventoryService = {
  async listItems(clubId: string): Promise<ApiResponse<InventoryItem[]>> {
    return apiGet<InventoryItem[]>(`/inventory/${clubId}/items`);
  },

  async createItem(clubId: string, data: Partial<InventoryItem>): Promise<ApiResponse<{ id: string }>> {
    return apiPost<{ id: string }>(`/inventory/${clubId}/items`, data);
  },

  async updateItem(
    clubId: string,
    itemId: string,
    data: Partial<InventoryItem>
  ): Promise<ApiResponse<null>> {
    return apiPatch<null>(`/inventory/${clubId}/items/${itemId}`, data);
  },

  async adjustStock(
    clubId: string,
    itemId: string,
    data: { delta: number; reason: InventoryStockAdjustReason; note?: string | null }
  ): Promise<ApiResponse<{ quantity: number }>> {
    return apiPost<{ quantity: number }>(`/inventory/${clubId}/items/${itemId}/adjust-stock`, data);
  },

  async deactivateItem(clubId: string, itemId: string): Promise<ApiResponse<null>> {
    return apiDelete<null>(`/inventory/${clubId}/items/${itemId}`);
  },

  async listHires(
    clubId: string,
    filters?: { from?: string; to?: string; status?: InventoryHire['status'] }
  ): Promise<ApiResponse<InventoryHireListRow[]>> {
    return apiGet<InventoryHireListRow[]>(`/inventory/${clubId}/hires`, { params: filters });
  },

  async createHire(clubId: string, data: Partial<InventoryHire>): Promise<ApiResponse<{ id: string }>> {
    return apiPost<{ id: string }>(`/inventory/${clubId}/hires`, data);
  },

  async returnHire(clubId: string, hireId: string): Promise<ApiResponse<null>> {
    return apiPost<null>(`/inventory/${clubId}/hires/${hireId}/return`, {});
  },

  async cancelHire(clubId: string, hireId: string): Promise<ApiResponse<null>> {
    return apiDelete<null>(`/inventory/${clubId}/hires/${hireId}`);
  },
};
